export class SearchCondition {
    public dateFrom: string
    public dateTo: string
}
